<template>
  <div class="topic-filter-bar mb-4">
    <div class="d-flex flex-wrap gap-2">
      <button
        class="btn topic-filter-btn"
        :class="selectedTopic === null ? 'btn-primary' : 'btn-outline-secondary'"
        @click="$emit('select-topic', null)"
      >
        All
      </button>
      <button
        v-for="topic in topics"
        :key="'filter-' + topic.id"
        class="btn topic-filter-btn"
        :class="selectedTopic === topic.id ? 'btn-primary' : 'btn-outline-secondary'"
        @click="$emit('select-topic', topic.id)"
      >
        {{ topic.name }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopicFilterBar',
  props: {
    topics: {
      type: Array,
      required: true
    },
    selectedTopic: {
      type: String,
      default: null
    }
  },
  emits: ['select-topic']
}
</script>

<style scoped>
.topic-filter-bar {
  background: white;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.topic-filter-btn {
  border-radius: 20px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
}
</style>
